
if (!customElements.get("shop-the-look-drawer")) {
  class ShopTheLookDrawer extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", this.init.bind(this));
      }
      this.init();
    }

    init() {
      this.toggleState = this.classList.contains("is--open");
      this.closeHandler = this.closeHandler || this.close.bind(this);
      this.openHandler = this.openHandler || this.open.bind(this);

      if (!document.querySelector("shop-the-look-drawer.is--open")) {
        document.body.classList.remove("overflow-hidden");
      }

      this.querySelector(".button--close")
        ?.addEventListener("click", this.closeHandler);
      this.querySelector(".shop-the-look-drawer__backdrop")
        ?.addEventListener("click", this.closeHandler);

      this.triggers = Array.from(
        document.querySelectorAll(".shop-the-look-drawer__trigger")
      ).filter((trigger) => trigger.getAttribute("aria-controls") === this.id);

      this.triggers.forEach((trigger) => {
        trigger.addEventListener("click", this.openHandler);
      });
    }

    toggle() {
      if (!this.toggleState) {
        this.open();
      } else {
        this.close();
      }
    }

    open(event) {
      this.toggleState = true;
      document.body.classList.add("overflow-hidden");
      this.classList.add("is--open");
      this.style.display = "block";
      this.toggleAriaExpanded(event);
    }

    close() {
      this.toggleState = false;
      this.classList.remove("is--open");
      this.style.display = "none";
      this.toggleAriaExpanded();

      if (!document.querySelector("shop-the-look-drawer.is--open")) {
        document.body.classList.remove("overflow-hidden");
      }
    }

    toggleAriaExpanded(event) {
      if (event) {
        const trigger = event.currentTarget || event.target.closest("button");
        trigger?.setAttribute("aria-expanded", "true");
        this.querySelector(".button--close")
          ?.setAttribute("aria-expanded", "true");
      } else {
        this.triggers?.forEach((trigger) => {
          trigger.setAttribute("aria-expanded", "false");
        });
        this.querySelector(".button--close")
          ?.setAttribute("aria-expanded", "false");
      }
    }

  }

  customElements.define("shop-the-look-drawer", ShopTheLookDrawer);
}
